import { render, staticRenderFns } from "./ResourceDetails.vue?vue&type=template&id=936fce5e&"
import script from "./ResourceDetails.vue?vue&type=script&lang=js&"
export * from "./ResourceDetails.vue?vue&type=script&lang=js&"
import style0 from "./ResourceDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports